// extracted by mini-css-extract-plugin
export var label = "_ca-5";
export var slideContainer = "_ca-0";
export var slider = "_ca-1";
export var sliderLg = "_ca-4";
export var sliderMd = "_ca-3";
export var sliderSm = "_ca-2";